import React from 'react';
import { FormattedMessage } from 'react-intl';
import logoTraderevColour from '../../../assets/external/openlane-logo.svg';
import { Container, Logo } from './Styles';

const PoweredBy = () => {
  return (
    <Container>
      <FormattedMessage id="tr5.poweredBy" />
      <Logo src={logoTraderevColour} />
    </Container>
  );
};

export default PoweredBy;
